var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvrtProfilePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0006 29.6693C17.9014 29.6693 20.7371 28.8091 23.149 27.1975C25.5609 25.5859 27.4408 23.2953 28.5509 20.6153C29.661 17.9353 29.9514 14.9863 29.3855 12.1413C28.8196 9.29623 27.4227 6.68288 25.3715 4.63171C23.3204 2.58054 20.707 1.18368 17.862 0.61776C15.0169 0.0518434 12.0679 0.342292 9.38796 1.45238C6.70798 2.56246 4.41736 4.44233 2.80576 6.85425C1.19417 9.26617 0.333984 12.1018 0.333984 15.0026C0.33735 18.8914 1.88366 22.62 4.63347 25.3698C7.38327 28.1196 11.1118 29.6659 15.0006 29.6693Z",
    fill: "url(#paint0_linear_51_3818)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6868 22.5655C15.1828 23.4287 13.3688 22.5496 13.3688 20.8223V9.34616C13.3688 7.61887 15.2486 6.53943 16.7516 7.40258L19.8334 9.02921C20.6408 9.46776 21.1422 10.31 21.1422 11.226C21.1422 13.1277 19.0939 14.3347 17.4164 13.4207L14.7811 12.0333L12.1349 10.5143C10.9538 9.83455 9.47266 10.6847 9.47266 12.0453V18.1242C9.47266 19.4847 10.9528 20.3369 12.1369 19.6551L14.7831 18.1362L17.3457 16.6939C18.3563 16.0799 19.658 16.2464 20.4823 17.0906C21.6275 18.2677 21.3564 20.2023 19.9291 21.0226L16.6849 22.5655H16.6868Z",
    stroke: "white",
    strokeWidth: 0.641975,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6096 17.4326L14.0851 21.1434C12.901 21.8232 11.4209 20.9729 11.4209 19.6124V10.5683C11.4209 9.20779 12.901 8.3556 14.0851 9.03735L20.7641 12.5886",
    stroke: "white",
    strokeWidth: 0.641975,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_3818",
    x1: 15.0007,
    y1: 0.335937,
    x2: 15.0007,
    y2: 29.6693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvrtProfilePic);
export default __webpack_public_path__ + "static/media/convrt_profile_pic.ac6244a9d9cc8d8420c52ea9232c4a91.svg";
export { ForwardRef as ReactComponent };